// @ts-nocheck
/* eslint-disable no-unused-vars */
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { TreeSelect } from 'antd';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';

export const SelectSubInventory = ({ value, onChange, organizationId }) => {
  const { t, i18n } = useTranslation();

  const { TreeSubInventoryData, loading, error } = useGetSubinventoryList();

  return (
    <>
      <TreeSelect
        loading={loading}
        showSearch
        className='w-100'
        treeLine
        placeholder={t('Choose')}
        allowClear
        treeDefaultExpandAll={false}
        value={value}
        onChange={onChange}
        treeData={TreeSubInventoryData?.filter(f => f.parentId === organizationId)}
        // treeData={TreeSubInventoryData}
        treeNodeFilterProp='title'
        getPopupContainer={triggerNode => triggerNode.parentNode} // يجعل القائمة تظهر داخل نفس عنصر الـ parent
      />
    </>
  );
};
